import { render } from "./leaderBord.vue?vue&type=template&id=10771194&scoped=true&ts=true"
import script from "./leaderBord.vue?vue&type=script&lang=ts"
export * from "./leaderBord.vue?vue&type=script&lang=ts"

import "./leaderBord.vue?vue&type=style&index=0&id=10771194&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10771194"]])

export default __exports__